export const savedMessage = {
  created() {
    this.$on('saved:data', this.showMessage.bind(this))

    if (Object.prototype.hasOwnProperty.call(this.$root, 'saved-msg')) {
      return
    }

    Object.defineProperty(this.$root, 'saved-msg', {
      value: this.createMessageElement(),
      writable: false
    })
  },
  computed: {
    savedMessage() {
      return this.$root['saved-msg']
    }
  },
  methods: {
    showMessage() {
      this.savedMessage.classList.remove('hide')
      setTimeout(() => {
        this.savedMessage.classList.add('hide')
      }, 4000)
    },
    createMessageElement() {
      let msgElement = document.createElement('div')
      msgElement.className = 'card card-message card-message-success hide'
      msgElement.innerText = this.$t('general.dataSaved')
      document.body.appendChild(msgElement)
      return msgElement
    }
  }
}
